import { Facebook, Instagram, Linkedin, Youtube, ArrowUpRight } from "lucide-react";

const XLogo = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);
import { Reveal, Eyebrow } from "./Reveal";
import { LogoMark } from "./Logo";
import { scrollToId } from "@/lib/scroll";

const socials = [
  { id: "twitter", label: "X", icon: XLogo, href: "https://twitter.com/desisciencepage" },
  { id: "facebook", label: "Facebook", icon: Facebook, href: "https://facebook.com/desisciencepage" },
  { id: "instagram", label: "Instagram", icon: Instagram, href: "https://www.instagram.com/desisciencepage/" },
  { id: "linkedin", label: "LinkedIn", icon: Linkedin, href: "https://www.linkedin.com/company/desisciencepage/" },
  { id: "youtube", label: "YouTube", icon: Youtube, href: "https://www.youtube.com/@KhojProject" },
];

export const Connect = () => (
  <section id="connect" data-testid="connect-section" className="px-5 sm:px-10 lg:px-16 pt-24 sm:pt-32 pb-10 border-t border-white/10">
    <Eyebrow className="mb-10">// Follow the evidence</Eyebrow>
    <ul className="border-t border-white/10">
      {socials.map(({ id, label, icon: Icon, href }, i) => (
        <Reveal key={id} delay={i * 0.06} y={20}>
          <li className="border-b border-white/10">
            <a
              data-testid={`social-link-${id}`}
              href={href}
              target="_blank"
              rel="noreferrer"
              className="group relative flex items-center justify-between py-6 sm:py-8 overflow-hidden"
            >
              <span className="absolute inset-0 bg-lime origin-bottom scale-y-0 group-hover:scale-y-100 transition-transform duration-500 ease-out" />
              <span className="relative flex items-center gap-5 sm:gap-8 group-hover:text-ink transition-colors duration-300 sm:group-hover:translate-x-6 transition-transform">
                <span className="font-mono text-[12px] text-zinc-400 group-hover:text-ink/70">0{i + 1}</span>
                <Icon className="w-6 h-6 sm:w-8 sm:h-8" />
                <span className="font-display font-bold uppercase text-3xl sm:text-5xl lg:text-6xl">{label}</span>
              </span>
              <ArrowUpRight className="relative w-7 h-7 sm:w-10 sm:h-10 text-lime group-hover:text-ink group-hover:rotate-45 transition-transform duration-500 mr-2" />
            </a>
          </li>
        </Reveal>
      ))}
    </ul>
    <footer className="mt-24 flex flex-col sm:flex-row items-start sm:items-end justify-between gap-8">
      <div className="flex items-center gap-4">
        <LogoMark className="w-12 h-12 text-lime animate-spin-slow" />
        <div>
          <p className="font-display font-bold text-xl">The Desi Science Page</p>
          <p className="font-mono text-[12px] uppercase tracking-[0.25em] text-zinc-400 mt-1">Curiosity | Science | Skepticism | Wonder</p>
        </div>
      </div>
      <button data-testid="back-to-top-btn" onClick={() => scrollToId("top")} className="font-mono text-[12px] uppercase tracking-[0.25em] text-zinc-300 hover:text-lime transition-colors">
        ↑ Back to top
      </button>
    </footer>
  </section>
);
